import Loadable from '../../components/loadable';

const MembershipInterruptionsList = Loadable({
  loader: () =>
    import('../../pages/contacts/membership_interruptions/membership_interruptions_list'),
  type: 'block',
});

angular.module('gym').value('MembershipInterruptionsList', MembershipInterruptionsList);
